var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref } from "vue";
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
import PublishedItem from "@/components/Common/PublishedItem.vue";
import HistoryView from "@/components/History/HistoryView.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryPublished',
    props: {
        id: null
    },
    setup(__props) {
        const props = __props;
        const history = ref();
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield GalaxyApi().GET("/api/histories/{history_id}", {
                params: {
                    path: { history_id: props.id },
                },
            });
            if (error) {
                rethrowSimple(error);
                return;
            }
            // The default view is the detailed view
            history.value = data;
        }));
        return { __sfc: true, props, history, PublishedItem, HistoryView };
    }
});
